module.exports = __webpack_public_path__ + "static/img/download_merchant_mobile.e00eb6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/download_merchant_mobile.png
// module id = 3rZc
// module chunks = 8